// Lead Sources List Component
// Shows where leads are coming from

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Link2 } from 'lucide-react';
import { COLORS } from './analyticsConstants';

const LeadSourcesList = ({ leadSources }) => {
  if (!leadSources) return null;

  return (
    <Card className="border-slate-200" data-testid="lead-sources">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Link2 className="w-5 h-5 text-teal-500" />
          Lead Sources
        </CardTitle>
        <CardDescription>Where your leads are coming from</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {leadSources.sources.length > 0 ? (
            leadSources.sources.slice(0, 5).map((source, idx) => (
              <div key={source.source} className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: idx === 0 ? COLORS.primary : `rgba(13, 148, 136, ${1 - (idx * 0.2)})` }}
                  />
                  <span className="text-sm text-slate-700">{source.source}</span>
                </div>
                <div className="text-right">
                  <span className="text-sm font-medium text-slate-900">{source.count}</span>
                  <span className="text-xs text-slate-400 ml-2">({source.percentage}%)</span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-slate-500 text-center py-4">No source data available</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default LeadSourcesList;
